import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Detail-view assembly: merges result.yaml (verdict truth), execution.json
 * (v4 instruction tree), and the steps/ folder scan (precise durations,
 * page URLs, screenshots) into the view models the detail page renders.
 * Pure and worker-portable; every input is independently optional and the
 * output degrades per-section (see the source ladder on DetailTreeVM).
 */

import { normalizeTestStatus, toSkinData } from './parse';

/** Failure context extracted from the per-step failure.yaml (via the root
 * index). anchorStepId = the index entry's `step` — page-state anchor only. */

/** The clone-safe raw bundle PackClient.readTestDetail returns — parsing
 * happened client-side; VM assembly (this module) is cheap and pure. */

/**
 * Both vocabularies normalize here, but they never compete: result.yaml's
 * value is used whenever the step exists there; execution.json's
 * success/error vocabulary is consulted only when result.yaml is silent.
 */
export function normalizeStepStatus(s) {
  if (s === 'passed' || s === 'failed' || s === 'skipped') return s;
  if (s === 'success') return 'passed';
  if (s === 'error') return 'failed';
  return 'unknown';
}
var asString = function asString(v) {
  return typeof v === 'string' && v !== '' ? v : undefined;
};
var asIdString = function asIdString(v) {
  return typeof v === 'string' && v !== '' ? v : typeof v === 'number' ? String(v) : undefined;
};
function toEnv(env) {
  if (!env) return {};
  return {
    os: asString(env.os),
    osVersion: asIdString(env.os_version),
    browser: asString(env.browser),
    browserVersion: asIdString(env.browser_version),
    resolution: asString(env.resolution),
    platform: asString(env.platform),
    skinUrl: asString(env.skin_url),
    skinData: toSkinData(env.skin_data),
    viewport: asString(env.viewport),
    device: asString(env.device),
    deviceSlug: asString(env.device_slug)
  };
}
function toStepVM(src) {
  var _leaf$status, _ref, _asString, _ref2, _src$ordinal, _ref3, _src$id, _ref4, _src$id2, _ref5, _ref6, _leaf$instruction, _leaf$command, _leaf$reasoning, _leaf$intent, _leaf$assertion, _leaf$api, _leaf$networkQuery, _leaf$networkAssertio, _leaf$customScript, _leaf$jsScript, _leaf$dbQuery, _leaf$visual, _asString2, _info$screenshotPath, _leaf$errorMessage, _ref7, _info$coordinates, _info$cursorViewport, _info$elementRect, _info$annotatedPath;
  var resultStep = src.resultStep,
    info = src.info,
    leaf = src.leaf;
  // Verdict: result.yaml wins whenever it authored this step.
  var status = resultStep ? normalizeStepStatus(resultStep.status) : normalizeStepStatus((_leaf$status = leaf === null || leaf === void 0 ? void 0 : leaf.status) !== null && _leaf$status !== void 0 ? _leaf$status : info === null || info === void 0 ? void 0 : info.status);
  var kind = (_ref = (_asString = asString(resultStep === null || resultStep === void 0 ? void 0 : resultStep.kind)) !== null && _asString !== void 0 ? _asString : asString(info === null || info === void 0 ? void 0 : info.kind)) !== null && _ref !== void 0 ? _ref : null;
  // Precise step.json duration first; result.yaml's rounded value only when
  // positive (its zeros mean "not measured", not "0 ms").
  var infoDuration = typeof (info === null || info === void 0 ? void 0 : info.duration_ms) === 'number' ? info.duration_ms : null;
  var resultDuration = typeof (resultStep === null || resultStep === void 0 ? void 0 : resultStep.duration_ms) === 'number' && resultStep.duration_ms > 0 ? resultStep.duration_ms : null;
  var ordinal = (_ref2 = (_src$ordinal = src.ordinal) !== null && _src$ordinal !== void 0 ? _src$ordinal : info === null || info === void 0 ? void 0 : info.ordinal) !== null && _ref2 !== void 0 ? _ref2 : null;
  return {
    key: (_ref3 = (_src$id = src.id) !== null && _src$id !== void 0 ? _src$id : leaf === null || leaf === void 0 ? void 0 : leaf.instructionId) !== null && _ref3 !== void 0 ? _ref3 : ordinal !== null ? "ord-".concat(ordinal) : "step-".concat(src.fallbackIndex),
    ordinal: ordinal,
    id: (_ref4 = (_src$id2 = src.id) !== null && _src$id2 !== void 0 ? _src$id2 : asString(info === null || info === void 0 ? void 0 : info.id)) !== null && _ref4 !== void 0 ? _ref4 : null,
    status: status,
    kind: kind,
    title: (_ref5 = (_ref6 = (_leaf$instruction = leaf === null || leaf === void 0 ? void 0 : leaf.instruction) !== null && _leaf$instruction !== void 0 ? _leaf$instruction : asString(info === null || info === void 0 ? void 0 : info.summary)) !== null && _ref6 !== void 0 ? _ref6 : kind) !== null && _ref5 !== void 0 ? _ref5 : ordinal !== null ? "Step ".concat(ordinal) : 'Step',
    command: (_leaf$command = leaf === null || leaf === void 0 ? void 0 : leaf.command) !== null && _leaf$command !== void 0 ? _leaf$command : null,
    reasoning: (_leaf$reasoning = leaf === null || leaf === void 0 ? void 0 : leaf.reasoning) !== null && _leaf$reasoning !== void 0 ? _leaf$reasoning : null,
    intent: (_leaf$intent = leaf === null || leaf === void 0 ? void 0 : leaf.intent) !== null && _leaf$intent !== void 0 ? _leaf$intent : null,
    assertion: (_leaf$assertion = leaf === null || leaf === void 0 ? void 0 : leaf.assertion) !== null && _leaf$assertion !== void 0 ? _leaf$assertion : null,
    api: (_leaf$api = leaf === null || leaf === void 0 ? void 0 : leaf.api) !== null && _leaf$api !== void 0 ? _leaf$api : null,
    networkQuery: (_leaf$networkQuery = leaf === null || leaf === void 0 ? void 0 : leaf.networkQuery) !== null && _leaf$networkQuery !== void 0 ? _leaf$networkQuery : null,
    networkAssertion: (_leaf$networkAssertio = leaf === null || leaf === void 0 ? void 0 : leaf.networkAssertion) !== null && _leaf$networkAssertio !== void 0 ? _leaf$networkAssertio : null,
    customScript: (_leaf$customScript = leaf === null || leaf === void 0 ? void 0 : leaf.customScript) !== null && _leaf$customScript !== void 0 ? _leaf$customScript : null,
    jsScript: (_leaf$jsScript = leaf === null || leaf === void 0 ? void 0 : leaf.jsScript) !== null && _leaf$jsScript !== void 0 ? _leaf$jsScript : null,
    dbQuery: (_leaf$dbQuery = leaf === null || leaf === void 0 ? void 0 : leaf.dbQuery) !== null && _leaf$dbQuery !== void 0 ? _leaf$dbQuery : null,
    visual: (_leaf$visual = leaf === null || leaf === void 0 ? void 0 : leaf.visual) !== null && _leaf$visual !== void 0 ? _leaf$visual : null,
    durationMs: infoDuration !== null && infoDuration !== void 0 ? infoDuration : resultDuration,
    url: (_asString2 = asString(info === null || info === void 0 ? void 0 : info.url)) !== null && _asString2 !== void 0 ? _asString2 : null,
    screenshotPath: (_info$screenshotPath = info === null || info === void 0 ? void 0 : info.screenshotPath) !== null && _info$screenshotPath !== void 0 ? _info$screenshotPath : null,
    effectiveScreenshotPath: null,
    // filled by the carry-forward pass below
    errorMessage: (_leaf$errorMessage = leaf === null || leaf === void 0 ? void 0 : leaf.errorMessage) !== null && _leaf$errorMessage !== void 0 ? _leaf$errorMessage : null,
    // step.json coordinates FIRST — the exec operations x/y is the dead
    // legacy path (producer contract 2026-07-09).
    cursor: (_ref7 = (_info$coordinates = info === null || info === void 0 ? void 0 : info.coordinates) !== null && _info$coordinates !== void 0 ? _info$coordinates : leaf === null || leaf === void 0 ? void 0 : leaf.cursor) !== null && _ref7 !== void 0 ? _ref7 : null,
    cursorViewport: (_info$cursorViewport = info === null || info === void 0 ? void 0 : info.cursorViewport) !== null && _info$cursorViewport !== void 0 ? _info$cursorViewport : null,
    elementRect: (_info$elementRect = info === null || info === void 0 ? void 0 : info.elementRect) !== null && _info$elementRect !== void 0 ? _info$elementRect : null,
    annotatedPath: (_info$annotatedPath = info === null || info === void 0 ? void 0 : info.annotatedPath) !== null && _info$annotatedPath !== void 0 ? _info$annotatedPath : null
  };
}
function rollup(steps) {
  if (steps.some(function (s) {
    return s.status === 'failed';
  })) return 'failed';
  if (steps.length > 0 && steps.every(function (s) {
    return s.status === 'passed';
  })) {
    return 'passed';
  }
  return 'unknown';
}

/** The dataset row's values, one per column, from execution.json
 * test_params (matched by name). Strings verbatim, others as JSON. */
export function datasetValues(dataset, params) {
  if (!dataset) return [];
  return dataset.columns.map(function (column) {
    var _params$find;
    var value = dataset.values && column in dataset.values ? dataset.values[column] : (_params$find = params.find(function (p) {
      return p.name === column;
    })) === null || _params$find === void 0 ? void 0 : _params$find.value;
    if (value === null || value === undefined) return null;
    return typeof value === 'string' ? value : JSON.stringify(value);
  });
}

/** kane trajectory final_status values meaning the objective was NOT
 * achieved (achieved runs report 'passed' or 'complete'). */
var FAILED_OBJECTIVE_STATUSES = new Set(['failed', 'error', 'assertion_error', 'stuck']);

/** "<objective index>-<n>" — the step-id shape kane packs author. */
var OBJECTIVE_STEP_ID = /^(\d+)-\d+$/;

/**
 * An objective (or module) card also fails when the agent failed the
 * objective without any step verdict failing — e.g. it got stuck after N
 * successful actions, so every result.yaml step reads passed. Two sources,
 * both joined through the card's step ids: failure.yaml's anchor step, and a
 * failed/stuck v16-trajectory summary whose index prefixes the step ids.
 * Only the card rollup changes; step verdicts still come from result.yaml.
 */
function markFailedObjectives(tree, anchorStepId, outcomes) {
  var failedIndexes = new Set(outcomes.filter(function (o) {
    var _o$finalStatus;
    return FAILED_OBJECTIVE_STATUSES.has((_o$finalStatus = o.finalStatus) !== null && _o$finalStatus !== void 0 ? _o$finalStatus : '');
  }).map(function (o) {
    return o.index;
  }));
  if (anchorStepId === null && failedIndexes.size === 0) {
    return tree;
  }
  var failsObjective = function failsObjective(step) {
    if (step.id === null) {
      return false;
    }
    if (step.id === anchorStepId) {
      return true;
    }
    var match = OBJECTIVE_STEP_ID.exec(step.id);
    return match !== null && failedIndexes.has(Number(match[1]));
  };
  var _mark = function mark(block) {
    var _block$blocks;
    var blocks = (_block$blocks = block.blocks) === null || _block$blocks === void 0 ? void 0 : _block$blocks.map(_mark);
    var isCard = block.objective !== null || block.module !== undefined;
    var failed = isCard && block.rollup !== 'failed' && block.steps.some(failsObjective);
    return _objectSpread(_objectSpread(_objectSpread({}, block), blocks ? {
      blocks: blocks
    } : {}), failed ? {
      rollup: 'failed'
    } : {});
  };
  return _objectSpread(_objectSpread({}, tree), {}, {
    blocks: tree.blocks.map(_mark)
  });
}

/** "Latest image" rule: a step without its own screenshot shows the most
 * recent prior one; leading steps with none get the explicit empty state. */
function carryForwardScreenshots(flat) {
  var last = null;
  var _iterator = _createForOfIteratorHelper(flat),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var step = _step.value;
      if (step.screenshotPath !== null) last = step.screenshotPath;
      step.effectiveScreenshotPath = last;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function buildTree(execution, resultSteps, infos) {
  var infoById = new Map();
  var infoByOrdinal = new Map();
  var infoByActionId = new Map();
  var _iterator2 = _createForOfIteratorHelper(infos),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var info = _step2.value;
      if (info.id) infoById.set(info.id, info);
      infoByOrdinal.set(info.ordinal, info);
      if (info.actionId) infoByActionId.set(info.actionId, info);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var hasExecution = execution !== null && execution.blocks.some(function (b) {
    return b.leaves.length > 0;
  });
  var hasResultSteps = resultSteps.length > 0;
  if (!hasExecution && !hasResultSteps) {
    // Step folders alone can still render a bare flat list.
    if (infos.length === 0) {
      return {
        blocks: [],
        flatSteps: [],
        source: 'empty'
      };
    }
    var steps = infos.map(function (info, i) {
      var _asString3;
      return toStepVM({
        ordinal: info.ordinal,
        id: (_asString3 = asString(info.id)) !== null && _asString3 !== void 0 ? _asString3 : null,
        resultStep: null,
        info: info,
        leaf: null,
        fallbackIndex: i
      });
    });
    carryForwardScreenshots(steps);
    return {
      blocks: [{
        key: 'flat',
        contentType: 'flat',
        objective: null,
        rollup: rollup(steps),
        steps: steps
      }],
      flatSteps: steps,
      source: 'result-only'
    };
  }
  if (!hasExecution) {
    // result.yaml only: flat list, one synthetic block.
    var _steps = resultSteps.map(function (rs, i) {
      var _asString4, _ref8, _ref9;
      return toStepVM({
        ordinal: typeof rs.ordinal === 'number' ? rs.ordinal : i + 1,
        id: (_asString4 = asString(rs.id)) !== null && _asString4 !== void 0 ? _asString4 : null,
        resultStep: rs,
        info: (_ref8 = (_ref9 = rs.id ? infoById.get(rs.id) : undefined) !== null && _ref9 !== void 0 ? _ref9 : infoByOrdinal.get(typeof rs.ordinal === 'number' ? rs.ordinal : i + 1)) !== null && _ref8 !== void 0 ? _ref8 : null,
        leaf: null,
        fallbackIndex: i
      });
    });
    carryForwardScreenshots(_steps);
    return {
      blocks: [{
        key: 'flat',
        contentType: 'flat',
        objective: null,
        rollup: rollup(_steps),
        steps: _steps
      }],
      flatSteps: _steps,
      source: 'result-only'
    };
  }

  // Execution tree present: leaves in document order; result.yaml steps are
  // claimed by action_id join first, then positionally.
  var claimed = new Set();
  var resolveResultIndex = function resolveResultIndex(leaf, globalIndex) {
    if (leaf.operationId) {
      // Producer contract 2026-07-09: result.yaml steps carry action_id ==
      // leaf operation_id — the direct join, no step.json needed.
      var direct = resultSteps.findIndex(function (rs, idx) {
        return !claimed.has(idx) && rs.action_id === leaf.operationId;
      });
      if (direct !== -1) return direct;
      var info = infoByActionId.get(leaf.operationId);
      if (info !== null && info !== void 0 && info.id) {
        var byId = resultSteps.findIndex(function (rs, idx) {
          return !claimed.has(idx) && rs.id === info.id;
        });
        if (byId !== -1) return byId;
      }
    }
    if (globalIndex < resultSteps.length && !claimed.has(globalIndex)) {
      return globalIndex;
    }
    return null;
  };
  var globalIndex = 0;

  /** Claim a result step for one executable leaf (document order). */
  var makeStep = function makeStep(leaf, nested) {
    var _asString5, _ref0, _ref1, _ref10, _leaf$mergedOperation;
    var ri = resolveResultIndex(leaf, globalIndex);
    if (ri !== null) claimed.add(ri);
    var rs = ri !== null ? resultSteps[ri] : null;
    var ordinal = rs && typeof rs.ordinal === 'number' ? rs.ordinal : hasResultSteps ? null : globalIndex + 1;
    var id = rs ? (_asString5 = asString(rs.id)) !== null && _asString5 !== void 0 ? _asString5 : null : null;
    var info = (_ref0 = (_ref1 = (_ref10 = id ? infoById.get(id) : undefined) !== null && _ref10 !== void 0 ? _ref10 : leaf.operationId ? infoByActionId.get(leaf.operationId) : undefined) !== null && _ref1 !== void 0 ? _ref1 : ordinal !== null ? infoByOrdinal.get(ordinal) : undefined) !== null && _ref0 !== void 0 ? _ref0 : null;
    var vm = toStepVM({
      ordinal: ordinal,
      id: id,
      resultStep: rs,
      info: info,
      leaf: leaf,
      fallbackIndex: globalIndex
    });
    if (nested) vm.nested = true;
    globalIndex += 1;
    // Sibling ops of the same authored step: claim their result steps so
    // they never surface as orphans; the card fails if any failed and its
    // duration covers all of them.
    var _iterator3 = _createForOfIteratorHelper((_leaf$mergedOperation = leaf.mergedOperationIds) !== null && _leaf$mergedOperation !== void 0 ? _leaf$mergedOperation : []),
      _step3;
    try {
      var _loop = function _loop() {
        var _infoByActionId$get$d, _infoByActionId$get;
        var opId = _step3.value;
        var mi = resultSteps.findIndex(function (r, idx) {
          return !claimed.has(idx) && r.action_id === opId;
        });
        if (mi === -1) return 1; // continue
        claimed.add(mi);
        globalIndex += 1;
        var merged = resultSteps[mi];
        if (normalizeStepStatus(merged.status) === 'failed') {
          vm.status = 'failed';
        }
        var extra = (_infoByActionId$get$d = (_infoByActionId$get = infoByActionId.get(opId)) === null || _infoByActionId$get === void 0 ? void 0 : _infoByActionId$get.duration_ms) !== null && _infoByActionId$get$d !== void 0 ? _infoByActionId$get$d : merged.duration_ms;
        if (typeof extra === 'number' && vm.durationMs !== null) {
          vm.durationMs += extra;
        }
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    return vm;
  };

  /**
   * Containers (conditional_block / until_block) become one UNCLAIMED
   * container VM (result.yaml has no row for them) followed — in document
   * order, so positional claiming stays aligned — by their nested children
   * marked `nested` (rendered inside the card, still in flatSteps).
   */
  var buildLeafVMs = function buildLeafVMs(leaf) {
    if (leaf.ifElse) {
      var container = toStepVM({
        ordinal: null,
        id: null,
        resultStep: null,
        info: null,
        leaf: leaf,
        fallbackIndex: globalIndex
      });
      var out = [container];
      var branches = leaf.ifElse.branches.map(function (br) {
        var steps = br.leaves.map(function (l) {
          return makeStep(l, true);
        });
        out.push.apply(out, _toConsumableArray(steps));
        return {
          label: br.label,
          condition: br.condition,
          passed: br.passed,
          subCheck: br.subCheck,
          steps: steps
        };
      });
      container.ifElse = {
        resolvedBranchIndex: leaf.ifElse.resolvedBranchIndex,
        branches: branches
      };
      return out;
    }
    if (leaf.until) {
      var _container = toStepVM({
        ordinal: null,
        id: null,
        resultStep: null,
        info: null,
        leaf: leaf,
        fallbackIndex: globalIndex
      });
      var _steps2 = leaf.until.leaves.map(function (l) {
        return makeStep(l, true);
      });
      _container.until = {
        label: leaf.until.label,
        condition: leaf.until.condition,
        conditionMet: leaf.until.conditionMet,
        currentCount: leaf.until.currentCount,
        maxRetries: leaf.until.maxRetries,
        steps: _steps2
      };
      return [_container].concat(_toConsumableArray(_steps2));
    }
    return [makeStep(leaf, false)];
  };

  /** A module's sub-groups build in sequence, so its `steps` is exactly
   * their concatenation and claiming stays in document order. */
  var _toBlockVM = function toBlockVM(block, fallbackKey) {
    if (block.blocks) {
      var groups = block.blocks.map(function (g, gi) {
        return _toBlockVM(g, "".concat(fallbackKey, "-").concat(gi));
      });
      var _steps3 = groups.flatMap(function (g) {
        return _toConsumableArray(g.steps);
      });
      return {
        key: block.key || fallbackKey,
        contentType: block.contentType,
        objective: block.objective,
        rollup: rollup(_steps3),
        steps: _steps3,
        module: block.module,
        blocks: groups
      };
    }
    var steps = block.leaves.flatMap(function (leaf) {
      return buildLeafVMs(leaf);
    });
    return {
      key: block.key || fallbackKey,
      contentType: block.contentType,
      objective: block.objective,
      rollup: rollup(steps),
      steps: steps
    };
  };
  var blocks = execution.blocks.map(function (block, bi) {
    return _toBlockVM(block, "block-".concat(bi));
  });

  // result.yaml steps no execution leaf claimed — producers drop failed
  // non-assert actions from the authoring tree, so these are real events
  // with no authored row. They join flatSteps FLAGGED as orphans: data
  // surfaces (RCA anchor, screenshots) see them, the tree never does.
  var orphans = resultSteps.map(function (rs, i) {
    return {
      rs: rs,
      i: i
    };
  }).filter(function (_ref11) {
    var i = _ref11.i;
    return !claimed.has(i);
  }).map(function (_ref12) {
    var _asString6, _ref13, _ref14;
    var rs = _ref12.rs,
      i = _ref12.i;
    return Object.assign(toStepVM({
      ordinal: typeof rs.ordinal === 'number' ? rs.ordinal : i + 1,
      id: (_asString6 = asString(rs.id)) !== null && _asString6 !== void 0 ? _asString6 : null,
      resultStep: rs,
      info: (_ref13 = (_ref14 = rs.id ? infoById.get(rs.id) : undefined) !== null && _ref14 !== void 0 ? _ref14 : infoByOrdinal.get(typeof rs.ordinal === 'number' ? rs.ordinal : i + 1)) !== null && _ref13 !== void 0 ? _ref13 : null,
      leaf: null,
      fallbackIndex: globalIndex + i
    }), {
      orphan: true
    });
  });
  if (orphans.length > 0 && blocks.length > 0) {
    var last = blocks[blocks.length - 1];
    var _steps4 = [].concat(_toConsumableArray(last.steps), _toConsumableArray(orphans));
    blocks[blocks.length - 1] = _objectSpread(_objectSpread({}, last), {}, {
      rollup: rollup(_steps4),
      steps: _steps4
    });
  } else if (orphans.length > 0) {
    blocks.push({
      key: 'flat',
      contentType: 'flat',
      objective: null,
      rollup: rollup(orphans),
      steps: orphans
    });
  }
  var flatSteps = blocks.flatMap(function (b) {
    return _toConsumableArray(b.steps);
  });
  carryForwardScreenshots(flatSteps);
  return {
    blocks: blocks,
    flatSteps: flatSteps,
    source: hasResultSteps ? 'merged' : 'execution-only'
  };
}

/**
 * How many ACTION steps a detail has: container wrappers (if/else, until)
 * are structure and orphan result steps have no authored row — neither is
 * a step the user can walk through. Nested children count (they are the
 * real actions inside the cards). Drives the steps-panel header and the
 * RCA drawer's "View all steps (N)" so both agree.
 */
export function actionStepCount(steps) {
  return steps.filter(function (s) {
    return !s.ifElse && !s.until && !s.orphan;
  }).length;
}

/**
 * Assemble the detail page's models. `row` is the already-hydrated list row
 * (seeds the header synchronously before any detail read resolves).
 */
export function buildDetailVM(testId, row, data) {
  var _data$execution$block, _data$execution, _ref15, _ref16, _row$status, _row$durationMs, _row$env, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _data$dataset, _ref26, _data$dataset2, _data$execution$testP, _data$execution2, _result$tags, _asString8, _data$failure$message, _data$failure$rootCau, _data$failure$suggest, _data$failure$anchorS, _result$steps, _data$failure$anchorS2, _data$failure, _data$objectiveOutcom;
  var runStartedAt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var result = data.result;
  var externalId = result && result.external_id && _typeof(result.external_id) === 'object' ? result.external_id : undefined;
  var firstObjective = (_data$execution$block = (_data$execution = data.execution) === null || _data$execution === void 0 || (_data$execution = _data$execution.blocks.find(function (b) {
    return b.objective;
  })) === null || _data$execution === void 0 ? void 0 : _data$execution.objective) !== null && _data$execution$block !== void 0 ? _data$execution$block : null;
  var rowTitle = row && row.title !== row.id ? row.title : null;
  // Same source as the list row (external_id.session_name) read from the
  // bundle itself — the row may still be hydrating when the detail lands.
  var sessionName = externalId ? asString(externalId.session_name) : undefined;
  var header = {
    testId: testId,
    title: (_ref15 = (_ref16 = sessionName !== null && sessionName !== void 0 ? sessionName : rowTitle) !== null && _ref16 !== void 0 ? _ref16 : firstObjective) !== null && _ref15 !== void 0 ? _ref15 : testId,
    status: result ? normalizeTestStatus(result.status) : (_row$status = row === null || row === void 0 ? void 0 : row.status) !== null && _row$status !== void 0 ? _row$status : 'unknown',
    durationMs: typeof (result === null || result === void 0 ? void 0 : result.duration_ms) === 'number' ? result.duration_ms : (_row$durationMs = row === null || row === void 0 ? void 0 : row.durationMs) !== null && _row$durationMs !== void 0 ? _row$durationMs : null,
    env: result ? toEnv(result.environment && _typeof(result.environment) === 'object' ? result.environment : undefined) : (_row$env = row === null || row === void 0 ? void 0 : row.env) !== null && _row$env !== void 0 ? _row$env : {},
    testcaseId: (_ref17 = (_ref18 = externalId ? asIdString(externalId.testcase_id) : undefined) !== null && _ref18 !== void 0 ? _ref18 : row === null || row === void 0 ? void 0 : row.testcaseId) !== null && _ref17 !== void 0 ? _ref17 : null,
    tcId: (_ref19 = (_ref20 = externalId ? asIdString(externalId.tc_id) : undefined) !== null && _ref20 !== void 0 ? _ref20 : row === null || row === void 0 ? void 0 : row.tcId) !== null && _ref19 !== void 0 ? _ref19 : null,
    projectId: (_ref21 = externalId ? asIdString(externalId.project_id) : undefined) !== null && _ref21 !== void 0 ? _ref21 : null,
    sharableLink: (_ref22 = externalId ? asString(externalId.sharable_link) : undefined) !== null && _ref22 !== void 0 ? _ref22 : null,
    hyperJobId: (_ref23 = externalId ? asString(externalId.hyper_job_id) : undefined) !== null && _ref23 !== void 0 ? _ref23 : null,
    datasetId: (_ref24 = externalId ? asIdString(externalId.dataset_id) : undefined) !== null && _ref24 !== void 0 ? _ref24 : null,
    dataset: (_ref25 = (_data$dataset = data.dataset) !== null && _data$dataset !== void 0 ? _data$dataset : row === null || row === void 0 ? void 0 : row.dataset) !== null && _ref25 !== void 0 ? _ref25 : null,
    datasetValues: datasetValues((_ref26 = (_data$dataset2 = data.dataset) !== null && _data$dataset2 !== void 0 ? _data$dataset2 : row === null || row === void 0 ? void 0 : row.dataset) !== null && _ref26 !== void 0 ? _ref26 : null, (_data$execution$testP = (_data$execution2 = data.execution) === null || _data$execution2 === void 0 ? void 0 : _data$execution2.testParams) !== null && _data$execution$testP !== void 0 ? _data$execution$testP : []),
    executedBy: function (_asString7) {
      var name = externalId ? asString(externalId.user_name) : undefined;
      if (!name) return null;
      return {
        name: name,
        email: (_asString7 = asString(externalId === null || externalId === void 0 ? void 0 : externalId.user_email)) !== null && _asString7 !== void 0 ? _asString7 : null
      };
    }(),
    tags: Array.isArray(result === null || result === void 0 ? void 0 : result.tags) ? ((_result$tags = result === null || result === void 0 ? void 0 : result.tags) !== null && _result$tags !== void 0 ? _result$tags : []).filter(function (t) {
      return typeof t === 'string';
    }) : [],
    videoPath: data.videoPath,
    videoUrl: (_asString8 = asString(result === null || result === void 0 ? void 0 : result.video_url)) !== null && _asString8 !== void 0 ? _asString8 : null,
    startedAt: runStartedAt,
    failure: data.failure ? {
      message: (_data$failure$message = data.failure.message) !== null && _data$failure$message !== void 0 ? _data$failure$message : null,
      rootCause: (_data$failure$rootCau = data.failure.rootCause) !== null && _data$failure$rootCau !== void 0 ? _data$failure$rootCau : null,
      suggestedFix: (_data$failure$suggest = data.failure.suggestedFix) !== null && _data$failure$suggest !== void 0 ? _data$failure$suggest : null,
      anchorStepId: (_data$failure$anchorS = data.failure.anchorStepId) !== null && _data$failure$anchorS !== void 0 ? _data$failure$anchorS : null
    } : null
  };
  var tree = markFailedObjectives(buildTree(data.execution, Array.isArray(result === null || result === void 0 ? void 0 : result.steps) ? (_result$steps = result === null || result === void 0 ? void 0 : result.steps) !== null && _result$steps !== void 0 ? _result$steps : [] : [], data.steps), (_data$failure$anchorS2 = (_data$failure = data.failure) === null || _data$failure === void 0 ? void 0 : _data$failure.anchorStepId) !== null && _data$failure$anchorS2 !== void 0 ? _data$failure$anchorS2 : null, (_data$objectiveOutcom = data.objectiveOutcomes) !== null && _data$objectiveOutcom !== void 0 ? _data$objectiveOutcom : []);
  return {
    header: header,
    tree: tree
  };
}

/** Header seed for the synchronous first paint (zero reads). */
export function seedDetailHeader(testId, row) {
  var _row$title, _row$status2, _row$durationMs2, _row$env2, _row$testcaseId, _row$tcId, _row$datasetId, _row$dataset;
  var runStartedAt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    testId: testId,
    title: (_row$title = row === null || row === void 0 ? void 0 : row.title) !== null && _row$title !== void 0 ? _row$title : testId,
    status: (_row$status2 = row === null || row === void 0 ? void 0 : row.status) !== null && _row$status2 !== void 0 ? _row$status2 : 'unknown',
    durationMs: (_row$durationMs2 = row === null || row === void 0 ? void 0 : row.durationMs) !== null && _row$durationMs2 !== void 0 ? _row$durationMs2 : null,
    env: (_row$env2 = row === null || row === void 0 ? void 0 : row.env) !== null && _row$env2 !== void 0 ? _row$env2 : {},
    testcaseId: (_row$testcaseId = row === null || row === void 0 ? void 0 : row.testcaseId) !== null && _row$testcaseId !== void 0 ? _row$testcaseId : null,
    tcId: (_row$tcId = row === null || row === void 0 ? void 0 : row.tcId) !== null && _row$tcId !== void 0 ? _row$tcId : null,
    projectId: null,
    sharableLink: null,
    hyperJobId: null,
    datasetId: (_row$datasetId = row === null || row === void 0 ? void 0 : row.datasetId) !== null && _row$datasetId !== void 0 ? _row$datasetId : null,
    dataset: (_row$dataset = row === null || row === void 0 ? void 0 : row.dataset) !== null && _row$dataset !== void 0 ? _row$dataset : null,
    datasetValues: [],
    executedBy: null,
    tags: [],
    videoPath: null,
    videoUrl: null,
    startedAt: runStartedAt,
    failure: null
  };
}